<div class="notificationToast__buttons">
  <button
    xm
    type="button"
    *ngFor="let button of toast.config.buttons"
    [ngClass]="{'notificationToast__buttons--bold': button.bold}"
    (click)="button.action ? button.action(toast) : remove()">
    {{button.text}}
  </button>
</div>
